<template>
  <symbol
    id="sort"
    viewBox="0 0 16 16"
  >
    <path
      d="M0.700012 0.999951C0.700012 0.834266 0.834327 0.699951 1.00001 0.699951H15C15.1657 0.699951 15.3 0.834266 15.3 0.999951V1.99995C15.3 2.07921 15.2686 2.15526 15.2128 2.21147L9.96701 7.48771V15C9.96701 15.107 9.91002 15.2059 9.81745 15.2595C9.72487 15.3132 9.61073 15.3134 9.51788 15.2603L6.18389 13.3503C6.09057 13.2968 6.03301 13.1975 6.03301 13.09V7.48771L0.787266 2.21147C0.731381 2.15526 0.700012 2.07921 0.700012 1.99995V0.999951ZM1.30001 1.29995V1.8762L6.54576 7.15243C6.60164 7.20864 6.63301 7.28469 6.63301 7.36395V12.9161L9.36701 14.4823V7.36395C9.36701 7.28469 9.39838 7.20864 9.45427 7.15243L14.7 1.8762V1.29995H1.30001Z"
    />
  </symbol>
</template>
